import React, {useEffect, useState} from 'react';
import './DynaRLookUpOpener.scss';
import RLookUpModal from "../../SellFactor/FactorKOL/RLookUpModal";

const DynaRLookUpOpener = ({
                             sendData,
                             setSendData,
                             requestId,
                             caption,
                             id,
                             keyName,
                             classname,
                             variables,
                             variableIsStringify,
                             getAllData
                           }) => {

  const [buttonCaption, setButtonCaption] = useState("");
  const [isOpen, setIsOpen] = useState(false);


  useEffect(() => {
    setButtonCaption(caption)
  }, [caption]);

  const dataHandler = (incomingData) => {
    setButtonCaption(incomingData.buttonCaption)
    setSendData({...sendData, [keyName]: incomingData[id]})
  }

  try {
    return (
      <div className={`main-open-RLookUp ${classname !== "" ? classname : ""}`}>
        <button onClick={() => setIsOpen(true)}>{buttonCaption}</button>

        {isOpen && <RLookUpModal
          id={requestId}
          callBackDataHandler={(incomingData) => {
            dataHandler(incomingData)
            getAllData(incomingData)
          }}
          variables={variables}
          variableIsStringify={variableIsStringify}
          modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
        />}
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default DynaRLookUpOpener;